<style lang="scss">
@import './base.scss';
</style>
<template>
  <div 
    class="line-box"
    :class="['start-line', {'end-line': endLine}, {'btn-line': btnLine}]">
    <span :style="{ 'background-color': [background ? '#f8f8f9' : '#FFFFFF'] }"></span>
  </div>
</template>
<script>
  export default {
    props: {
      btnLine: Boolean,
      endLine: Boolean,
      background: Boolean,
    },
  };
</script>
